import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
const EmailTemplateManagement = ({ children }) => {
  const Navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/admin/email") {
      Navigate("/admin/email/list-email-template");
    }
  }, [location, Navigate]);

  return (
    <div className="mt-4 ">
      <section>
        <div className="container">
          <div className="row">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmailTemplateManagement;


